// src/services/api.js
import { useAuth } from '../contexts/AuthContext';

export function useApi() {
    const { token } = useAuth();

    // Requisições autenticadas com JSON (padrão)
    const authenticatedFetch = async (url, options = {}) => {
        const headers = {
            'Content-Type': 'application/json',
            ...(options.headers || {}),
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        };

        const config = {
            ...options,
            headers,
        };

        return fetch(url, config);
    };

    // Requisições autenticadas com FormData
    const authenticatedFormFetch = async (url, formData, options = {}) => {
        const headers = {
            ...(options.headers || {}),
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        };

        const config = {
            method: 'POST',
            ...options,
            headers,
            body: formData,
        };

        return fetch(url, config);
    };

    // Requisições públicas com JSON
    const publicFetch = async (url, options = {}) => {
        const headers = {
            'Content-Type': 'application/json',
            ...(options.headers || {}),
        };

        const config = {
            ...options,
            headers,
        };

        return fetch(url, config);
    };

    return { authenticatedFetch, authenticatedFormFetch, publicFetch };
}